// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + {"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] + "." + {"189":"d69f2cd1643cb0220c9a","404":"b804fbb5c3c7f8035199","406":"1422e08d0149e83123ec"}[chunkId] + ".css";
};